/**
 * Client-side Blockdaemon SDK instance
 * Initialized directly to communicate with Blockdaemon APIs
 */
import { BdSdk } from "@blockdaemon/bd-sdk";

// Initialize BdSdk with basePath set to local /sdk proxy
// SDK requests are routed through /sdk/* which proxies to Blockdaemon services
export const blockdaemonSDK = new BdSdk({ basePath: `${window.location.origin}/sdk` });
